import { ReactNode } from 'react';
import mitt from 'mitt';

export type InboxCallItemEvents = {
  callTagsExternalSync: { channelId: string; tagIds: string[] };
  openCallInsightPanel: {
    channelId: string;
    includeCallIntelligence: boolean;
    locationId: string;
    autoplayRecording?: boolean;
  };
  openVoicemailInsightPanel: {
    voicemailId: string;
    locationId: string;
    autoplayRecording?: boolean;
  };
  openMessageInsightsPanel: {
    messageId: string;
    threadId: string;
    locationId: string;
    createdAt?: string;
    escalationSubject?: string;
    escalationBody?: string;
    outcomeBubbleNode?: ReactNode;
  };
};

// Global event emitter for inbox call item events
export const inboxCallItemEventBus = mitt<InboxCallItemEvents>();

// Helper functions for emitting events
export const emitCallTagsExternalSync = (data: InboxCallItemEvents['callTagsExternalSync']) => {
  inboxCallItemEventBus.emit('callTagsExternalSync', data);
};

export const emitOpenCallInsightPanel = (data: InboxCallItemEvents['openCallInsightPanel']) => {
  inboxCallItemEventBus.emit('openCallInsightPanel', data);
};

export const emitOpenVoicemailInsightPanel = (data: InboxCallItemEvents['openVoicemailInsightPanel']) => {
  inboxCallItemEventBus.emit('openVoicemailInsightPanel', data);
};

export const emitOpenMessageInsightsPanel = (data: InboxCallItemEvents['openMessageInsightsPanel']) => {
  inboxCallItemEventBus.emit('openMessageInsightsPanel', data);
};
